/* ==========================================================================
   ZGN Conversion Engine — sepet önerileri ve hediye hedefi
   Yalnızca ilgili özellik açıkken yüklenir. Sepet işlemleri theme.js ile aynı
   Shopify AJAX uç noktalarını kullanır; sahte veri üretmez.
   ========================================================================== */
(function () {
  'use strict';
  var T = window.zgnTheme || {};
  var CE = T.ce || {};
  var root = (T.routes && T.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  function url(p) { return root + p.replace(/^\//, ''); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function refresh() { if (T.refreshCart) return T.refreshCart(); return Promise.resolve(); }

  /* ---------- Sepet önerileri ---------- */
  var recoCache = {};
  function fillRecos() {
    if (!CE.recos) return;
    qsa('[data-ce-recos]').forEach(function (box) {
      var pid = box.getAttribute('data-product-id');
      if (!pid) return;
      var key = pid + '|' + box.getAttribute('data-intent');
      var list = box.querySelector('[data-ce-recos-list]');
      var show = parseInt(box.getAttribute('data-show'), 10) || 4;
      function render(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('[data-ce-recos-result]');
        var cards = res ? qsa('.zgn-ce-card', res).slice(0, show) : [];
        list.innerHTML = '';
        cards.forEach(function (c) { list.appendChild(document.importNode(c, true)); });
        box.hidden = cards.length === 0;
      }
      if (recoCache[key]) { render(recoCache[key]); return; }
      fetch(url('recommendations/products?product_id=' + encodeURIComponent(pid) + '&limit=' + (box.getAttribute('data-limit') || 6) + '&section_id=ce-recommendations&intent=' + (box.getAttribute('data-intent') || 'related')))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { recoCache[key] = html; render(html); })
        .catch(function () {});
    });
  }

  /* ---------- Hediye hedefi ---------- */
  var giftBusy = false;
  var DECLINED = 'zgnGiftDeclined';
  function declined() { try { return sessionStorage.getItem(DECLINED) === '1'; } catch (e) { return false; } }
  function setDeclined() { try { sessionStorage.setItem(DECLINED, '1'); } catch (e) {} }
  var hadGift = null;
  function checkGift(cart) {
    var g = CE.gift;
    if (!g || !g.variant || !cart || giftBusy) return;
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    var goal = Math.round(g.threshold * rate);
    var giftLine = -1, sub = cart.items_subtotal_price;
    cart.items.forEach(function (it, i) {
      if (it.properties && it.properties._zgn_gift) { giftLine = i + 1; sub -= it.final_line_price; }
    });
    var has = giftLine > 0;
    // müşteri hediyeyi kendisi kaldırdıysa bir daha ekleme
    if (hadGift === true && !has && sub >= goal) setDeclined();
    hadGift = has;
    if (sub >= goal && !has && !declined() && cart.item_count > 0) {
      giftBusy = true;
      fetch(url('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: g.variant, quantity: 1, properties: { _zgn_gift: '1' } }] }) })
        .then(function () { hadGift = true; return refresh(); })
        .catch(function () {})
        .then(function () { giftBusy = false; });
    } else if (sub < goal && has) {
      giftBusy = true;
      fetch(url('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: giftLine, quantity: 0 }) })
        .then(function () { hadGift = false; return refresh(); })
        .catch(function () {})
        .then(function () { giftBusy = false; });
    }
  }

  document.addEventListener('cart:rendered', fillRecos);
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) checkGift(e.detail.cart); });

  function boot() {
    fillRecos();
    if (CE.gift) {
      fetch(url('cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { hadGift = cart.items.some(function (it) { return it.properties && it.properties._zgn_gift; }); checkGift(cart); })
        .catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
